import { Reveal, MaskLines } from "./motion";
import { GALLERIES } from "../../lib/assets";
import { GlassCard, DeviceMock } from "./Glass";

export const RWA = () => {

  return (
    <section
      id="rwa"
      data-testid="rwa-section"
      className="relative flex min-h-screen items-center overflow-hidden bg-canvas px-6 pb-24 pt-28 md:px-12"
    >

      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-16 lg:grid-cols-2">
        <div>
          <h2 className="font-display text-4xl font-light leading-[0.95] tracking-tight text-ink md:text-6xl">
            <MaskLines lines={["Tokeniza activos", "reales. Traspásalos", "con un toque."]} />
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-md font-body text-base leading-relaxed text-ink-soft md:text-lg">
              Representa inmuebles y activos del mundo real como tokens sobre la
              FSC. Consulta su NAV, revisa datos, fotos y documentos, y
              traspásalos de forma segura.
            </p>
          </Reveal>

          <GlassCard delay={0.15} className="mt-10 max-w-sm p-6">
            <span className="font-accent text-xs uppercase tracking-[0.2em] text-ink-soft">
              NAV / valor
            </span>
            <div className="mt-2 font-display text-4xl font-medium tracking-tight text-ink">
              1,500,000.00 <span className="text-2xl text-ink-soft">MXF</span>
            </div>
            <div className="mt-3 flex gap-2">
              <span className="rounded-full bg-ink/10 px-3 py-1 font-accent text-xs text-ink-soft">
                PLAZAP30
              </span>
              <span className="rounded-full bg-forest/15 px-3 py-1 font-accent text-xs text-forest">
                ACTIVE
              </span>
            </div>
          </GlassCard>
        </div>

        <GlassCard testId="rwa-device" delay={0.15} className="p-8 md:p-10">
          <DeviceMock
            src={GALLERIES.rwa[0].src}
            alt={GALLERIES.rwa[0].alt}
            className="min-h-[440px]"
            imgClassName="max-h-[540px]"
          />
        </GlassCard>
      </div>
    </section>
  );
};
